import { FC, useContext, useState } from "react"
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import './scenariomodal.css'
import { ScenarioTable } from "./ScenarioTable/ScenarioTable";
import {  AiFillSetting } from 'react-icons/ai'
import { MdEdit } from 'react-icons/md'
import { IScenariosTable } from "../../../models/HomeModel";
import { UserContext } from "../../../Redux/UserContext";
import { BsCalendar2MonthFill } from "react-icons/bs";
import { ChangeCampaignModal } from "./ChangeCampaignModal/ChangeCampaignModal";

export const ScenarioModal:FC<any> = (props):JSX.Element => {

    const { scenarios, visible, setVisible, selectedScenario, history, flag, setFlag } = props
    
    const [state] = useContext(UserContext)

    const [visibleChangeYear, setVisibleChangeYear] = useState<boolean>(false)

    const [selectedRow, setSelectedRow] = useState<IScenariosTable>({
        id_scenario: -1,
        name_scenario: "",
        creation_date: ""
    })

    const handleEditScenario = () => {
        history.push(`/scenario_view/${selectedRow.id_scenario}/${selectedRow.id_scenario}`)
    }

    const handleChangeCampaignYear = () => {
        setVisibleChangeYear(true)
    }

   
    const handleScenarioRecovery = () => {
        history.push(`/home/${selectedScenario.id_plant}`)
        setVisible(false)
    }

    const headerContent = (
        <div className="scenarios-header">
            <span>Selector de escenarios - {selectedScenario.name_plant} ({selectedScenario.type_scenario})</span>
        </div>
    )
    

    const footerContent = (
        <div className="scenarios-footer">
            <Button severity={'success'} style={{minWidth:200}} label="Visualizar/Editar" icon={<MdEdit style={{fontSize:20}} />}  onClick={handleEditScenario} outlined disabled={selectedRow.id_scenario === -1} />
            <Button severity={'danger'} style={{minWidth:200}} label="Cambiar año campaña" icon={<BsCalendar2MonthFill style={{fontSize:20,marginRight:'1rem'}} />}  onClick={handleChangeCampaignYear} outlined  />
            <Button severity={'secondary'} style={{minWidth:200}} label="Administrar escenarios" icon={<AiFillSetting style={{fontSize:20,marginRight:'1rem'}} />}  onClick={handleScenarioRecovery} disabled={(state?.rol_id === 3 || state?.rol_id === 4) || !state?.id_plants.includes(selectedScenario.id_plant)} outlined  />
        </div>
    );


    return (
        <div className="card flex justify-content-center">
            <Dialog header={headerContent} visible={visible} style={{ width: '50vw' }} onHide={() => setVisible(false)} footer={footerContent}>
                <div className="scenario-modal-container">
                    <ScenarioTable data={scenarios} setSelectedRow={setSelectedRow} selectedRow={selectedRow} />
                </div>
            </Dialog>
            <ChangeCampaignModal
                visible={visibleChangeYear}
                setVisible={setVisibleChangeYear}
                id={selectedScenario.id_plant}
                name={selectedScenario.name_plant}
                anio={selectedScenario.anio ?? 2024}
                flag={flag}
                setFlag={setFlag}
            />
        </div>
    )
}